import { Box, Card, CardHeader, CardBody, Heading, Text, Button } from '@chakra-ui/react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { EmailBillingForm } from '@/components/forms/EmailBillingForm'

export default function EmailBillingToClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams<{ shippingLineId: string; billingStatementId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const billingStatementIdFromParams = params.billingStatementId ? parseInt(params.billingStatementId, 10) : undefined

  // Get data from navigation state or route params
  const navigationState = location.state as
    | {
        shippingLineName?: string
        shippingLineId?: string
        billingStatementId?: number
      }
    | null
  const shippingLineName = navigationState?.shippingLineName || ''
  const finalShippingLineId =
    navigationState?.shippingLineId || paramsShippingLineId
  const finalBillingStatementId = navigationState?.billingStatementId ?? billingStatementIdFromParams
  const validBillingStatementId =
    typeof finalBillingStatementId === 'number' && Number.isFinite(finalBillingStatementId) ? finalBillingStatementId : null

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Email Billing Statement to Client
            </Heading>
          </CardHeader>
          <CardBody>
            {validBillingStatementId == null ? (
              <Box>
                <Text color={colors.textSecondary} mb={4}>
                  Invalid Billing Statement. Cannot send email.
                </Text>
                <Button size="sm" variant="outline" onClick={handleCancel}>
                  Cancel
                </Button>
              </Box>
            ) : (
              <EmailBillingForm
                shippingLineName={shippingLineName}
                billingStatementId={validBillingStatementId}
                onSuccess={handleSuccess}
                onCancel={handleCancel}
              />
            )}
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

